import Box from "@mui/material/Box";
import { AddButton } from "app/components/Button/AddButton";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import AddBackWallTypeModal from "./components/AddBackWallTypeModal";
import BackWallTypeTable from "./components/BackWallTypeTable";
import {
  selectBackWallTypeList,
  selectBackWallTypeLoading,
  selectBackWallTypeMeta,
} from "./redux/selector";
import backWallTypeSaga from "./redux/saga";
import { backWallTypeActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const BackWallType = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: backWallTypeSaga,
  });

  const rows = useSelector(selectBackWallTypeList);
  const loading = useSelector(selectBackWallTypeLoading);
  const meta = useSelector(selectBackWallTypeMeta);

  useEffect(() => {
    dispatch(backWallTypeActions.getBackWallTypeList());
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(backWallTypeActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb
            title={t("SIDEBAR.REAR_WALL_TYPE")}
            iconPosition="end"
          />
          <Box dir="ltr">
            <AddButton
              label={t("BACK_WALL_TYPE.ACTIONS.ADD")}
              onClick={() => dispatch(backWallTypeActions.openAddModal())}
            />
          </Box>
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <BackWallTypeTable rows={rows} loading={loading} />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddBackWallTypeModal />
    </Box>
  );
};

export default BackWallType;
